import {
  reqGetCustomers,
  reqDeleteCustomer,
  reqGetCustomer,
  reqSaveCustomer,
  reqGetCustomerId,
  // reqGetCustomerById
} from "@/api/api.js";

const state = {
  customersList: {},
  customersInfo: [],
  customersFind: {},
  // customersUsers:[]
  customerId: "",
};
const mutations = {
  GETCUSTOMERSLIST(state, customersList) {
    state.customersList = customersList;
  },
  GETCUSTOMERSINFO(state, customersInfo) {
    state.customersInfo = customersInfo;
  },
  GETCUSTOMERSFIND(state, customersFind) {
    state.customersFind = customersFind;
  },
  // GETCUSTOMERSUSERS(state, customersUsers) {
  //   state.customersUsers = customersUsers;
  // },
  GETCUSTOMERID(state, customerId) {
    state.customerId = customerId;
  },
};
const actions = {
  async getCustomersList({ commit }, params = {}) {
    let result = await reqGetCustomers(params);
    if (result.status === 200) {
      commit("GETCUSTOMERSLIST", result.data);
      commit("GETCUSTOMERSINFO", result.data.data);
    }
  },
  async deleteCustomer({ commit }, id) {
    let result = await reqDeleteCustomer(id);
    if (result.status === 200) {
      return "ok";
    }
  },
  async getCustomersFind({ commit }, params = {}) {
    let result = await reqGetCustomer(params);
    if (result.status === 200) {
      commit("GETCUSTOMERSFIND", result.data);
    }
  },
  async saveCustomer({ commit }, data) {
    let result = await reqSaveCustomer(data);
    if (result.status === 200) {
      return "ok";
    }
  },
  async getCustomerId({ commit }, data) {
    let result = await reqGetCustomerId(data);
    if (result.status === 200) {
      commit("GETCUSTOMERID", result.data.id.id);
    }
  },
  // async getCustomerById({ commit },data) {
  //   let result = await reqGetCustomerById(data);
  //   console.log("r",result);
  //   if (result.status === 200) {
  //     commit("GETCUSTOMERSUSERS", result.data);
  //   }
  // },
};
const getters = {
  customersList(state) {
    return state.customersList || {};
  },
  customersFind(state) {
    if (state.customersFind.name) {
      const date = new Date(state.customersFind.createdTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var min = date.getMinutes();
      min = min < 10 ? "0" + min : min;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      state.customersFind.createdTime =
        y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
    }
    return state.customersFind || {};
  },
  customersInfo(state) {
    for (let i = 0; i < state.customersInfo.length; i++) {
      const date = new Date(state.customersInfo[i].createdTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var min = date.getMinutes();
      min = min < 10 ? "0" + min : min;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      state.customersInfo[i].createdTime =
        y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
    }
    return state.customersInfo || [];
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
